import { createAsyncThunk } from '@reduxjs/toolkit'

import { GREEDY_LINE_BREAK_REGEX } from '../../constants/utility-constants'
import { AppDispatch, RootState } from '../../reducers'
import currentPlaySlice from '../../reducers/currentPlaySlice'
import { selectCurrentTrackInfo } from '../../selectors/current-play-selectors'
import { selectScoreVersion } from '../../selectors/session-selectors'
import Gamer from '../../services/Gamer'
import analyzeLRC from '../../util/lyrics/analyze-lrc'
import { getTrackPoints } from '../../util/score-utils'
import { updateLocalTrack } from '../authoring/update-local-track'

const timingChanged = createAsyncThunk<void, Gamer, { state: RootState; dispatch: AppDispatch }>(
  'authoring/timingChanged',
  (gamer, { dispatch, getState }) => {
    const state = getState()
    const scoreVersion = selectScoreVersion(state)
    const { slug: trackSlug, duration } = selectCurrentTrackInfo(state)
    const { vizBuilder } = gamer
    const { sections, timedWordCount } = vizBuilder
    const currentLRC = gamer.currentLRC
    const emptyAirtime = analyzeLRC(sections, duration)
    dispatch(
      updateLocalTrack({
        trackSlug,
        audioData: { timing: currentLRC, emptyAirtime, timedWordCount, isInfoDirty: true },
      })
    )
    const timingLines = currentLRC.split(GREEDY_LINE_BREAK_REGEX)
    dispatch(currentPlaySlice.actions.setLRClines(timingLines))
    dispatch(currentPlaySlice.actions.setIsTimingDirty(true))
    dispatch(currentPlaySlice.actions.setIsScoreDirty(false))
    const scoreDuration = scoreVersion === 1 ? duration : duration - emptyAirtime
    const { pointsPerWord, wordDensity } = getTrackPoints(timedWordCount, scoreDuration)
    gamer.pointsPerWord = pointsPerWord
    console.log(
      `timingChanged for ${trackSlug}: difficulty=${wordDensity} pointPerWord=${pointsPerWord})`
    )
  }
)

export default timingChanged
